import React, { useState } from 'react'
import {
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  Avatar,
  Box,
  Typography,
  Collapse,
} from '@mui/material'
import classes from './Sidebar.module.css'
import {
  chalkwidettx,
  classIcon,
  dashboard,
  employee,
  expense,
  fees,
  help,
  holiday,
  newlogo,
  routes,
  sales,
  school,
  signOut,
  student,
  teacher,
  van,
  vanDriver,
} from '../../../../assets/icons'
import { useDispatch } from 'react-redux'
import { setCreditOpen } from '../../../../redux/globalSlice'
import { ExpandLess, ExpandMore } from '@mui/icons-material'

const drawerWidth = '240px'

const menuItems = [
  { text: 'Dashboard', image: dashboard, component: 'Dashboard' },
  { text: 'School', image: school, component: 'School' },
  { text: 'Employee', image: employee, component: 'Employee' },
  { text: 'Sales Analytics', image: sales, component: 'Sales Analytics' },
  { text: 'Holidays', image: holiday, component: 'Holidays' },
  { text: 'Time Table', image: holiday, component: 'Time Table' },
]

const classItems = [
  { text: 'Subject', image: classIcon, component: 'Subject' },
  { text: 'Class', image: classIcon, component: 'Class' },
  { text: 'Student', image: student, component: 'Student' },
  { text: 'Teacher', image: teacher, component: 'Teacher' },
]
const presenceItems = [
  { text: 'Student', image: student, component: 'Student Presence' },
  { text: 'Employee', image: teacher, component: 'Employee Presence' },
]

const financeItems = [
  { text: 'Fees', image: fees, component: 'Fees' },
  { text: 'Expenses', image: expense, component: 'Expenses' },
]

const vanItems = [
  { text: 'Student List', image: vanDriver, component: 'Student List' },
  {
    text: 'Van',
    image: van,
    component: 'Van',
    options: [
      {
        text: 'Van Driver',
        component: 'Van Driver',
      },
      {
        text: 'Vehicle',
        component: 'Van',
      },
      {
        text: 'Routes',
        component: 'Routes',
      },
    ],
  },
  // { text: 'Expense', image: routes, component: 'Expense' },
]

const logItems = [
  { text: 'LogOut', image: signOut, component: 'Logout' },
  { text: 'Help & Support', image: help, component: 'Help & Support' },
]

const Sidebar = ({ setSelectedComponent, selectedComponent }) => {
  // const [activeIndex, setActiveIndex] = useState(0)
  const [vanOpen, setVanOpen] = useState(false) // ← control collapse state (true = open by default)

  const storedAttributes = localStorage.getItem('userAttributes')
  const attributes = JSON.parse(storedAttributes || '{}')
  const dispatch = useDispatch()
  const customRole = attributes?.employee_type

  const handleListItem = (index, component) => {
    dispatch(setCreditOpen(false))
    // setActiveIndex(index)
    if (component) {
      setSelectedComponent(component)
    }
  }

  const toggleVan = () => {
    setVanOpen((prev) => !prev)
  }

  const renderListItems = (items, menuName) => (
    <List className={classes['dasboard-list']} disablePadding>
      <Typography className={classes.ListName}>{menuName}</Typography>

      {items.map((item, idx) => {
        const isParentActive =
          item.options && item.options.some((opt) => selectedComponent === opt.component)

        const isItemActive = selectedComponent === item.component || isParentActive

        if (item.options) {
          // ── VAN parent item with arrow ──
          return (
            <React.Fragment key={item.text}>
              <ListItem disablePadding>
                <ListItemButton
                  onClick={() => {
                    toggleVan()
                    // handleListItem(idx, item.component)
                  }}
                  sx={{
                    backgroundColor: isItemActive ? 'action.selected' : 'transparent',
                    '&:hover': { backgroundColor: 'action.hover' },
                  }}
                >
                  <img
                    src={item.image}
                    alt="chalkwide"
                    className={`${classes['list-item-image']} ${isItemActive ? 'svg-to-black' : ''}`}
                  />
                  <ListItemText primary={item.text} />
                  {vanOpen ? <ExpandLess fontSize="small" /> : <ExpandMore fontSize="small" />}
                </ListItemButton>
              </ListItem>

              <Collapse in={vanOpen} timeout="auto" unmountOnExit>
                <List component="div" disablePadding>
                  {item.options.map((sub) => {
                    const subActive = selectedComponent === sub.component
                    return (
                      <ListItemButton
                        key={sub.text}
                        sx={{
                          pl: 6, // ← indentation for children
                          backgroundColor: subActive ? 'action.selected' : 'transparent',
                          '&:hover': { backgroundColor: 'action.hover' },
                        }}
                        onClick={() => handleListItem(idx, sub.component)}
                      >
                        <ListItemText
                          primary={sub.text}
                          primaryTypographyProps={{
                            fontSize: '0.92rem',
                            fontWeight: subActive ? 600 : 400,
                          }}
                        />
                      </ListItemButton>
                    )
                  })}
                </List>
              </Collapse>
            </React.Fragment>
          )
        }

        // Normal items
        return (
          <ListItem
            key={item.text}
            disablePadding
            className={selectedComponent === item.component ? classes['active-list-item'] : ''}
          >
            <ListItemButton onClick={() => handleListItem(idx, item.component)}>
              <img
                src={item.image}
                alt="chalkwide"
                className={`${classes['list-item-image']} ${isItemActive ? 'svg-to-black' : ''}`}
              />
              <ListItemText primary={item.text} />
            </ListItemButton>
          </ListItem>
        )
      })}
    </List>
  )

  const filteredMenuItems = menuItems.filter((item) => {
    if (item.text === 'School') return customRole === 'Superadmin'
    return true
  })

  return (
    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
          backgroundColor: '#F9FAFB',
          color: '#000',
        },
      }}
      variant="permanent"
      anchor="left"
    >
      <Box className={classes['toolbar-dashboard']}>
        <div className={classes.LogoHead}>
          <img src={newlogo} alt="" />
          <img src={chalkwidettx} alt="" />
        </div>
      </Box>

      {/* <Box
        className={classes.AdminProfile}
        onClick={() => {
          dispatch(setCreditOpen(false))
          setSelectedComponent('Profile')
        }}
      >
        <Box className={classes.innerProfile}>
          <Avatar
            variant="rounded"
            alt={attributes?.employee_name}
            src={attributes?.employee_avatar || attributes?.employee_name}
            sx={{ width: '36px', height: '36px', bgcolor: '#F2ECF9', color: '#492972' }}
          />
          <Typography className={classes.adminText}>{attributes?.employee_name}</Typography>
        </Box>
        <Typography className={classes.adminEmail}>{attributes?.email}</Typography>
      </Box> */}

      <div className={classes['menu-list-items']}>
        {renderListItems(filteredMenuItems, 'MENU')}
        {renderListItems(presenceItems, 'PRESENCE')}
        {renderListItems(classItems, 'CLASS')}
        {renderListItems(financeItems, 'FINANCE')}
        {renderListItems(vanItems, 'TRANSPORT')}
        {renderListItems(logItems)}
      </div>
    </Drawer>
  )
}

export default Sidebar
